module.exports = __webpack_public_path__ + "img/no1.d94020a4.png";